import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV, SITE } from "../lib/site";

export default function Header() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header className="glass-header sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 h-20 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3 group shrink-0">
          <span className="block w-8 h-8 border border-[#c9a04b]/70 flex items-center justify-center shrink-0">
            <span className="font-serif italic text-gold text-lg">Q</span>
          </span>
          <div className="leading-none whitespace-nowrap">
            <div className="font-serif text-cream text-lg tracking-wide">{SITE.brand}</div>
            <div className="text-[9px] uppercase tracking-[0.28em] text-gold/80 mt-1">{SITE.tagline}</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-4 xl:gap-6">
          {NAV.map(n => {
            const isAccent = n.to === "/appreciation";
            return (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-[12px] uppercase tracking-[0.22em] font-medium transition-colors relative ${
                    isActive ? "text-gold" : isAccent ? "text-gold/90 hover:text-gold" : "text-cream/70 hover:text-cream"
                  }`
                }
              >
                {isAccent && <span aria-hidden="true" className="inline-block w-1.5 h-1.5 bg-gold rounded-full mr-2 align-middle" />}
                {n.label}
              </NavLink>
            );
          })}
        </nav>

        <div className="flex items-center gap-3">
          <Link to="/book" data-testid="book-now-header-button" className="btn-primary hidden md:inline-flex !py-3 !px-5 !text-[11px]">
            Book Now
          </Link>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-cream p-2 border border-[#c9a04b]/30"
            onClick={() => setOpen(o => !o)}
            aria-label="Open menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#c9a04b]/15 bg-charcoal" data-testid="mobile-menu">
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-4">
            {NAV.map(n => (
              <NavLink
                key={n.to}
                to={n.to}
                className={({ isActive }) =>
                  `text-sm uppercase tracking-[0.2em] py-2 ${
                    isActive ? "text-gold" : "text-cream/80"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link to="/book" className="btn-primary mt-3" data-testid="book-now-mobile-menu">Book Now</Link>
          </div>
        </div>
      )}
    </header>
  );
}
